import { render } from "./Payments.vue?vue&type=template&id=3cd95be4"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=3cd95be4&lang=css"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Pay/id/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__